import Component from './campaign_status.vue'
export default Component
